import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import UtmsChip from '@shared/components/ui/UtmsChip';
import { Booking } from '../types';
import { useTranslation } from 'react-i18next';
import { UserProfile } from '@features/users';
import { formatBookingDate } from '@pages/booking/utils';
import { getDatesDifferenceFromDateRange } from '@shared/utils/utils';

interface BookingDeviceModalBookingViewProps {
    bookingForItem: Booking;
}

const BookingDeviceModalBookingView: FC<BookingDeviceModalBookingViewProps> = ({ bookingForItem }) => {
    const { t } = useTranslation();

    return (
        <>
            <Typography sx={{ fontSize: '1rem', mb: 1 }}>{t('booked_by')}</Typography>
            <UserProfile createdUserId={bookingForItem.created_by_user} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {`${formatBookingDate(new Date(bookingForItem.booked_from))} - ${formatBookingDate(new Date(bookingForItem.booked_to))}`}
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {Boolean(bookingForItem.slots?.length) && (
                        <UtmsChip label={t('slots', { count: bookingForItem.slots?.length })} />
                    )}
                    <UtmsChip
                        label={(([days, hours]) =>
                            ''
                                .concat(days ? `${days}${t('day_short')}${hours ? ' ' : ''}` : '')
                                .concat(hours ? `${hours}${t('hour_short')}` : ''))(
                            getDatesDifferenceFromDateRange(bookingForItem.booked_from, bookingForItem.booked_to),
                        )}
                    />
                </Box>
            </Box>
        </>
    );
};

export default BookingDeviceModalBookingView;
